import { useEffect, useState } from "react";
import styled from "styled-components";

import LabelSection from "src/components/core/LabelSection";

import { Black, Focused, White, White01 } from "src/styles/color";
import { hexToRgba } from "src/common/color";

import { arrayMove } from "@dnd-kit/sortable";
import DraggableBoard, {
  DraggableItem,
} from "src/components/core/DraggableBoard";

import { moveFeaturePosition, getFeatures } from "src/api/landingPage";

const S = {};

S.BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: ${White};
  box-shadow: 0px 4px 20px ${hexToRgba(Black, 0.1)};
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

S.MainFeaturesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

S.Feature = styled(DraggableItem)`
  width: 80px;
  display: flex;
  flex-direction: column;
  margin: 0 10px;
  text-align: center;
  align-items: center;
  cursor: pointer;

  :hover {
    div {
      border: 1px solid ${Focused};
    }
  }
`;

S.WrapperFeatureImg = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 16px;
  border: 1px solid ${White01};
  background-color: ${White01};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
`;

S.FeatureName = styled.span`
  font-size: 0.75rem;
  color: ${Black};
  font-weight: 400;
  margin-top: 7px;
`;

const Features = () => {
  const [features, setFeatures] = useState([]);

  const fetchFeatures = async () => {
    try {
      const features = await getFeatures();
      setFeatures(features);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchFeatures();
  }, []);

  return (
    <S.BoxWrapper>
      <LabelSection title="ฟีเจอร์" description={`สลับตำแหน่งได้เท่านั้น`}>
        <DraggableBoard
          items={features}
          onDragEnd={async ({ active, over }) => {
            if (active.id !== over?.id) {
              const oldIndex = features.findIndex(
                (item) => item._id === active.id,
              );
              const newIndex = features.findIndex(
                (item) => item._id === over.id,
              );

              const newReArranged = arrayMove(features, oldIndex, newIndex);

              setFeatures(newReArranged); // optimistic update

              try {
                await moveFeaturePosition(newReArranged);
              } catch (err) {
                setFeatures(features); // if error, revert to original order
                console.error(err);
              }
            }
          }}
          Components={{
            DroppableParent: ({ items, children }) => {
              return (
                <S.MainFeaturesContainer>
                  {children({ items })}
                </S.MainFeaturesContainer>
              );
            },
            DraggableItem: (props) => {
              const { item: feature, items, ...rest } = props; // Destructuring items to prevent this spreading to html element
              return (
                <S.Feature {...rest}>
                  <S.WrapperFeatureImg>
                    <img
                      src={feature.image}
                      alt={feature.name_th}
                      style={{
                        maxWidth: "100%",
                      }}
                    />
                  </S.WrapperFeatureImg>
                  <S.FeatureName>{feature.name_th}</S.FeatureName>
                </S.Feature>
              );
            },
          }}
        />
      </LabelSection>
    </S.BoxWrapper>
  );
};

export default Features;
